import { useDispatch } from "hooks/useDispatch"
import { Dropdown } from "primereact/dropdown"
import { Skeleton } from "primereact/skeleton"
import { useCallback, useEffect, useState } from "react"

import { debounce } from "common/utils/utils"
import "./style.scss"

const VirtualDropdown = ({
  options,
  onChange,
  handleOnScroll,
  loading,
  startPage,
  fetchCallback,
  initialQueryParameters,
  userKey,
  setIsSelectFilterActive,
  fetchOnMount,
  totalCount,
  value,
  errorMsg,
  className,
  onBlur,
  resetArray,
  customFilterKey,
  id,
  name,
  ...props
}: $TSMigrationFixMe) => {
  const initialValues = {
    librado: {
      currentPages: startPage,
      currentFilterValue: "",
    },
    librador: {
      currentPages: startPage,
      currentFilterValue: "",
    },
  }
  const [currentUserParameters, setCurrentUserParameters] =
    useState(initialValues)

  const dispatch = useDispatch()

  useEffect(() => {
    fetchOnMount && fetchCallback(initialQueryParameters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchOnMount, initialQueryParameters])

  const onHandleScroll = useCallback(
    (value: $TSMigrationFixMe) => {
      dispatch(setIsSelectFilterActive(false))
      if (
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        value.last >= currentUserParameters[userKey].currentPages &&
        options.length <= totalCount
      ) {
        const queryParam = {
          ...initialQueryParameters,
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
          skipCount: currentUserParameters[userKey].currentPages,
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
          razonSocial: currentUserParameters[userKey].currentFilterValue,
        }
        setCurrentUserParameters({
          ...currentUserParameters,
          [userKey]: {
            currentPages:
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
              currentUserParameters[userKey].currentPages + startPage,
            currentFilterValue: value.filter,
          },
        })
        handleOnScroll(queryParam)
      }
    },
    [
      currentUserParameters,
      dispatch,
      handleOnScroll,
      initialQueryParameters,
      options.length,
      setIsSelectFilterActive,
      startPage,
      totalCount,
      userKey,
    ]
  )

  const onHandleFilter = (value: $TSMigrationFixMe) => {
    setCurrentUserParameters({
      ...currentUserParameters,
      [userKey]: {
        currentPages: startPage,
        currentFilterValue: value.filter,
      },
    })

    dispatch(setIsSelectFilterActive(true))
    const searchQuery = customFilterKey ? [customFilterKey] : "razonSocial"

    const queryParam = {
      ...initialQueryParameters,
      // @ts-expect-error TS(2464): A computed property name must be of type 'string',...
      [searchQuery]: value.filter,
    }

    value.originalEvent && fetchCallback(queryParam)
  }

  const onHandleSearchDebouce = debounce(onHandleFilter)
  const onShow = () => {
    dispatch(setIsSelectFilterActive(true))
    resetArray && dispatch(resetArray())
    setCurrentUserParameters(initialValues)
    const queryParam = {
      ...initialQueryParameters,
      razonSocial: "",
    }
    !fetchOnMount && fetchCallback(queryParam)
  }

  return (
    <>
      <Dropdown
        className={`${className} ${errorMsg && !value ? "p-invalid" : ""}`}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        onFilter={onHandleSearchDebouce}
        value={value}
        resetFilterOnHide
        onShow={onShow}
        id={id}
        name={name}
        virtualScrollerOptions={{
          lazy: true,
          onLazyLoad: onHandleScroll,
          itemSize: 52,
          showLoader: true,
          loading,
          loadingTemplate: (options) => {
            return (
              <div className='flex p-2 align-items-center skeleton__container'>
                <Skeleton
                  width={options.even ? "60%" : "50%"}
                  height='1rem'
                />
              </div>
            )
          },
        }}
        {...props}
      />
      {errorMsg && !value ? (
        <small className='p-error p-d-block'>{errorMsg}</small>
      ) : null}
    </>
  )
}

export default VirtualDropdown
